<div class="ot-about-wrapper">
  <div class="ot-close-button-wrapper">
    <button [mat-dialog-close] class="ot-close-button"></button>
  </div>
  <div class="ot-about-header-layout">
    <img src="assets/images/about_file360.svg">
    <p class="ot-version">Version&nbsp;{{productVersion}}</p>
  </div>
  <div class="ot-tab-system">
    <!-- ot-tab-wrapper to allow for white border around selected tab-->
    <div [ngClass]="{'ot-tab-wrapper-selected': selectedTab == 0}">
      <button class="ot-tab-button" [ngClass]="{'ot-tab-button-selected': selectedTab == 0}" (click)="selectTab(0)"
        cdkFocusInitial>About</button>
    </div>
    <div [ngClass]="{'ot-tab-wrapper-selected': selectedTab == 1}">
      <button class="ot-tab-button" [ngClass]="{'ot-tab-button-selected': selectedTab == 1}"
        (click)="selectTab(1)">System
        information</button>
    </div>
    <div [ngClass]="{'ot-tab-wrapper-selected': selectedTab == 2}">
      <button class="ot-tab-button" [ngClass]="{'ot-tab-button-selected': selectedTab == 2}"
        (click)="selectTab(2)">Contact
        information</button>
    </div>
  </div>
  <div class="ot-separator"></div>
  <div class="ot-tab-content-wrapper">
    <div class="ot-tab-content" [ngClass]="{'ot-tab-content-selected': selectedTab == 0}">
      <span class="ot-version-text">
        <span class="ot-bold">File360</span> - {{productVersion}}
        <br />
        <br />
      </span>
      Copyright &copy; {{year}} Open&nbsp;Text. All rights reserved. OpenText is a trademark or registered trademark of
      Open&nbsp;Text.
      The list of trademarks is not exhaustive of other trademarks, registered trademarks, product names, company
      names,
      brands and service names mentioned herein are property of Open&nbsp;Text or other respective owners.
      <br />
      <br />
      One or more patents may cover this product.
      <br />
      For more information, please visit, <a class="ot-about-link"
        href="https://www.opentext.com/patents">https://www.opentext.com/patents</a>
      <br />
      <br />
      <span class="ot-bold">Disclaimer</span>
      <br /> No Warranties and Limitation of Liability.
      <br /> Every effort has been made to ensure the accuracy of the features and techniques presented in this
      publication. However,
      Open&nbsp;Text Corporation and its affiliates accept no responsibility and offer no warranty whether expressed or
      implied,
      for the accuracy of this publication.
      <br />
      <br />
      <span class="ot-bold">Warning:</span> This software is protected by copyright law and international treaties.
      Unauthorized reproduction or
      distribution of this program, or any portion of it, may result in severe civil and criminal penalties, and will
      be
      prosecuted to the maximum extent possible under the law.
    </div>
    <div class="ot-tab-content" [ngClass]="{'ot-tab-content-selected': selectedTab == 1}" [innerHtml]="systemInfo">
    </div>
    <div class="ot-tab-content" [ngClass]="{'ot-tab-content-selected': selectedTab == 2}">
      OpenText Website
      <br />
      <a class="ot-about-link" href="https://www.opentext.com">https://www.opentext.com</a>
      <br />
      <br />Customer Support
      <br />
      <a class="ot-about-link" href="https://support.opentext.com">https://support.opentext.com</a>
    </div>
  </div>
</div>